import { CriterionTemplate } from '@evidentid/tprm-portal-lib/models/decisioning/Criterion.model';
import { toTprmRequirementType } from '@evidentid/tprm-portal-lib/utils/common/toTprmRequirementType';

import {
    EditableRequirementCriterion,
} from '@/modules/decisioning-criteria/models/EditableRequirements.model';

export const isSpecialConditionSetsCriterion = (
    criterion: EditableRequirementCriterion,
): boolean => criterion.coverageType === toTprmRequirementType('COMMERCIAL_GENERAL_LIABILITY') &&
     criterion.field === 'coverage.generalAggregateLimit' &&
     Boolean(criterion.references.conditionSets);

export const isInformationBannerVisible = (
    criterion: EditableRequirementCriterion,
    template: CriterionTemplate,
): boolean => Boolean(template.displayMetadata.informationText) || isSpecialConditionSetsCriterion(criterion);
